import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import { ToastProvider } from "@/components/ui/Toast";
import { MutationErrorToaster } from "@/components/MutationErrorToaster";
import { initSentry } from "@/lib/sentry";
import "@/lib/i18n";
import "./index.css";
import App from "./App";

initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <MutationErrorToaster />
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>
);
